module.exports = __webpack_public_path__ + "img/william-logos.b3707732.png";